import { useState, useEffect, useCallback } from "react";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import ContactSection from "./components/ContactSection";
import CommentsSection from "./components/CommentsSection";
import FeaturesSection from "./components/FeaturesSection";
import AppSection from "./components/AppSection";
import RankingSection from "./components/RankingSection";
import FAQSection from "./components/FAQSection";
import CarouselSection from "./components/CarouselSection";
import IndexSection from "./components/IndexSection";
import MediaSection from "./components/MediaSection";
import CardsSection from "./components/CardsSection";
import TopicsSection from "./components/TopicsSection";
import UpdatesSection from "./components/UpdatesSection";

const navItems = [
  { label: "首页", href: "#hero" },
  { label: "黑料热度榜", href: "#ranking" },
  { label: "深度猛料", href: "#cards" },
  { label: "焦点深扒", href: "#carousel" },
  { label: "常见疑问", href: "#faq" },
];

export default function Home() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 60);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  const handleNavClick = (href: string) => {
    setMobileMenuOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="relative min-h-screen bg-background-50 text-foreground-100">
      {/* Header */}
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/50"
            : "bg-transparent"
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16">
          <a
            href="#hero"
            onClick={(e) => {
              e.preventDefault();
              handleNavClick("#hero");
            }}
            className="font-heading text-xl md:text-2xl font-bold text-primary-400 hover:text-primary-300 transition-colors whitespace-nowrap"
          >
            爆料专区
          </a>

          {/* Desktop nav */}
          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(item.href);
                }}
                className="whitespace-nowrap px-3 py-2 text-sm text-foreground-400 hover:text-foreground-100 transition-colors rounded-md hover:bg-background-200/30 cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>

          {/* Mobile hamburger */}
          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <i
              className={`text-foreground-300 text-xl ${
                mobileMenuOpen ? "ri-close-line" : "ri-menu-line"
              }`}
            ></i>
          </button>
        </div>

        {/* Mobile menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-background-50/98 backdrop-blur-md border-b border-background-200/50">
            <nav className="px-4 py-3 flex flex-col gap-1">
              {navItems.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavClick(item.href);
                  }}
                  className="whitespace-nowrap px-3 py-2.5 text-sm text-foreground-400 hover:text-foreground-100 transition-colors rounded-md hover:bg-background-200/30 cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>
        )}
      </header>

      {/* Main Content */}
      <main>
        <HeroSection />
        <AboutSection />
        <ContactSection />
        <CommentsSection />
        <FeaturesSection />
        <AppSection />
        <RankingSection />
        <FAQSection />
        <CarouselSection />
        <IndexSection />
        <MediaSection />
        <CardsSection />
        <TopicsSection />
        <UpdatesSection />
      </main>

      {/* Footer */}
      <footer id="footer" className="w-full bg-background-900 border-t border-background-200/30">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <h3 className="font-heading text-lg text-primary-400 mb-4">爆料专区</h3>
              <p className="text-foreground-500 text-sm leading-relaxed">
                深扒黑料内幕与黑料真相，聚焦网红明星争议事件。
                提供不为人知的负面猛料与深度挖掘，你的验证与猎奇第一站。
              </p>
            </div>

            <div>
              <h4 className="text-foreground-300 text-sm font-semibold mb-4">快速导航</h4>
              <div className="flex flex-col gap-2">
                {navItems.slice(0, 4).map((item) => (
                  <a
                    key={item.href}
                    href={item.href}
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavClick(item.href);
                    }}
                    className="text-foreground-500 hover:text-foreground-200 text-sm transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-foreground-300 text-sm font-semibold mb-4">联系方式</h4>
              <div className="flex flex-col gap-2 text-foreground-500 text-sm">
                <span>投稿：tips@baoliao.live</span>
                <span>合作：biz@baoliao.live</span>
                <span>申诉：legal@baoliao.live</span>
              </div>
            </div>

            <div>
              <h4 className="text-foreground-300 text-sm font-semibold mb-4">合作伙伴</h4>
              <p className="text-foreground-600 text-xs leading-relaxed">
                合作伙伴信息即将上线，敬请期待。
              </p>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-200/30 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-foreground-600 text-xs">
              &copy; {new Date().getFullYear()} 爆料专区. 本站内容仅供信息参考，不构成任何法律建议。
            </p>
            <div className="flex items-center gap-4">
              <a href="#hero" className="text-foreground-600 hover:text-foreground-400 text-xs transition-colors cursor-pointer">隐私政策</a>
              <a href="#hero" className="text-foreground-600 hover:text-foreground-400 text-xs transition-colors cursor-pointer">用户协议</a>
              <a href="#hero" className="text-foreground-600 hover:text-foreground-400 text-xs transition-colors cursor-pointer">免责声明</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}